module.exports = __webpack_public_path__ + "static/media/marker-red.05c46a98.png";